'use client';

import { useMemo } from 'react';

import { defaultLocale, domainToLocaleMapping } from '@/core/constants';

// Get all unique locale values from the domain mapping
const allLocales = Array.from(
  new Set(Object.values(domainToLocaleMapping)),
).join('|');

// Create regex once at module level for better performance
const pathLocaleRegex = new RegExp(`localhost:\\d+/(${allLocales})(?:/|$)`);

function evaluateLocaleFromURL(href: string) {
  const matchedLocale = Object.keys(domainToLocaleMapping).find(
    (localeIdentifier) => href.includes(localeIdentifier),
  ) as keyof typeof domainToLocaleMapping;

  // In the event the array is empty, it implies there is no TLD and is therefore `localhost`
  if (!matchedLocale) {
    // Check for path-based locale on localhost (e.g., /es/, /de/, /fr/, /nl/)
    // This handles URLs like http://localhost:3000/es/cart
    const pathLocaleMatch = href.match(pathLocaleRegex);
    if (pathLocaleMatch) {
      return pathLocaleMatch[1] as string;
    }
    return defaultLocale;
  }

  return domainToLocaleMapping[matchedLocale];
}

export default function useLocale() {
  const href = globalThis.location?.href;

  const locale: string = useMemo(() => {
    if (typeof globalThis.location === 'undefined') {
      return defaultLocale;
    }

    return evaluateLocaleFromURL(href);
  }, [href]);

  return locale;
}
